function showBrowserNotification(title, body, icon) {
  if (!("Notification" in window)) {
    console.warn("This browser does not support system notifications.");
    return;
  }

  if (Notification.permission === "granted") {
    new Notification(title, {
      body,
      icon, // optional
    });
  } else if (Notification.permission !== "denied") {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        new Notification(title, {
          body,
          icon,
        });
      }
    });
  }
}

export default showBrowserNotification;
